import React, { useRef, useState } from 'react';
import axiosInstance, { API_BASE_URL } from '../../utils/axiosConfig';
import { toast } from 'react-toastify';

export interface GaleriOgesi {
    projeGaleriID: number;
    gorselYolu: string;
    aciklama?: string | null;
    sira: number;
}

interface Props {
    projeID: number;
    kategori: string;
    ogeler: GaleriOgesi[];
    onChange: (ogeler: GaleriOgesi[]) => void;
}

// Proje Sayfası'ndaki çoklu görsel gerektiren bölümlerin ortak yöneticisi
// (Kapak Manşet, Vaziyet Planı, Dış Mekan / Konum-Çevre / İç Mekan / Sosyal Alanlar
// bölümlerinin görselleri). Her görsele açıklama eklenebilir.
const GaleriYonetici: React.FC<Props> = ({ projeID, kategori, ogeler, onChange }) => {
    const fileRef = useRef<HTMLInputElement>(null);
    const [yukleniyor, setYukleniyor] = useState(false);

    const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setYukleniyor(true);
        try {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('aciklama', 'Proje Sayfası Görseli');
            const up = await axiosInstance.post('/api/Dosyalar/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            const res = await axiosInstance.post('/api/ProjeSayfa/galeri', {
                projeID, kategori, gorselYolu: up.data.dosyaAdi, aciklama: '', sira: 0,
            });
            onChange([...ogeler, res.data]);
        } catch {
            toast.error('Görsel yüklenirken hata oluştu.');
        } finally {
            setYukleniyor(false);
            if (fileRef.current) fileRef.current.value = '';
        }
    };

    const handleAciklama = async (id: number, aciklama: string) => {
        onChange(ogeler.map(o => (o.projeGaleriID === id ? { ...o, aciklama } : o)));
    };

    const handleAciklamaKaydet = async (oge: GaleriOgesi) => {
        try {
            await axiosInstance.post(`/api/ProjeSayfa/galeri/update/${oge.projeGaleriID}`, {
                projeGaleriID: oge.projeGaleriID, projeID, kategori, gorselYolu: oge.gorselYolu,
                aciklama: oge.aciklama, sira: oge.sira,
            });
        } catch {
            toast.error('Açıklama kaydedilemedi.');
        }
    };

    const handleSil = async (id: number) => {
        try {
            await axiosInstance.post(`/api/ProjeSayfa/galeri/delete/${id}`);
            onChange(ogeler.filter(o => o.projeGaleriID !== id));
        } catch {
            toast.error('Silinirken hata oluştu.');
        }
    };

    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12, marginBottom: 12 }}>
                {ogeler.map(oge => (
                    <div key={oge.projeGaleriID} style={{ border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden', background: '#fff' }}>
                        <div style={{ position: 'relative', aspectRatio: '4/3', background: '#f1f5f9' }}>
                            <img src={`${API_BASE_URL}/userFiles/${oge.gorselYolu}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                            <button type="button" onClick={() => handleSil(oge.projeGaleriID)} title="Sil"
                                style={{ position: 'absolute', top: 6, right: 6, width: 24, height: 24, borderRadius: '50%', border: 'none', background: 'rgba(15,23,42,0.65)', color: '#fff', cursor: 'pointer', fontSize: 11, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <input
                            type="text"
                            placeholder="Açıklama..."
                            value={oge.aciklama || ''}
                            onChange={e => handleAciklama(oge.projeGaleriID, e.target.value)}
                            onBlur={() => handleAciklamaKaydet(oge)}
                            style={{ width: '100%', padding: '6px 8px', border: 'none', borderTop: '1px solid #f1f5f9', fontSize: 11.5, boxSizing: 'border-box', outline: 'none' }}
                        />
                    </div>
                ))}
            </div>
            <input ref={fileRef} type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
            <button type="button" onClick={() => fileRef.current?.click()} disabled={yukleniyor}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 8, border: '1.5px dashed #cbd5e1', background: '#f8fafc', color: '#64748b', fontSize: 12.5, fontWeight: 600, cursor: yukleniyor ? 'not-allowed' : 'pointer' }}>
                <i className={yukleniyor ? 'fas fa-spinner fa-spin' : 'fas fa-plus'}></i>
                {yukleniyor ? 'Yükleniyor...' : 'Görsel Ekle'}
            </button>
        </div>
    );
};

export default GaleriYonetici;
